import { BhContentEmptyComponent } from './bh-content-empty.component';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    BhContentEmptyComponent
    ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  exports: [
    BhContentEmptyComponent
  ]
})
export class BhContentEmptyComponentModule { }